import { createAction, props } from '@ngrx/store';

import BetslipActions from '../../base/store/actions';

export default class TrackingActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/tracking`;

    private static readonly SET_LD_ACTIVE_EXPERIMENT = `${TrackingActions.ACTION_SCHEMA}/SET_LD_ACTIVE_EXPERIMENT`;

    static setLaunchDarklyActiveExperiment = createAction(TrackingActions.SET_LD_ACTIVE_EXPERIMENT, props<{ id: string }>());
}
